import { Box, Typography, Stack } from "@mui/material";
import imgSpitiExpedition from "../../Images/spitivalley.png";

const SpitiExpedition = () => {
  return (
    <Box
      sx={{
        px: { xs: 2, md: 8 },
        py: { xs: 4, md: 8 }
      }}
    >
      <Stack
        direction={{ xs: "column", md: "row" }}
        spacing={{ xs: 4, md: 8 }}
        alignItems="center"
      >
        {/* LEFT – TEXT */}
        <Box flex={1}>
          <Typography variant="h4" fontWeight={800} mb={2}>
            Spiti Valley Expedition
          </Typography>

          <Typography variant="body1" color="text.secondary" mb={2}>
            Spiti Valley is a high-altitude cold desert nestled in the Himalayas,
            known for its dramatic landscapes, ancient monasteries, and raw
            natural beauty. This expedition takes you through remote mountain
            roads, crystal-clear rivers, and peaceful villages untouched by
            modern chaos.
          </Typography>

          <Typography variant="body1" color="text.secondary">
            From the serene monasteries of Tabo and Key to the surreal beauty of
            Chandratal Lake, the journey is designed for travelers seeking
            adventure, spirituality, and unforgettable experiences in one of
            India’s most breathtaking regions.
          </Typography>
        </Box>

        {/* RIGHT – IMAGE (FULLY VISIBLE) */}
        <Box
          flex={1}
          sx={{
            width: "100%",
            height: { xs: 280, md: 500 },
            borderRadius: 3,
            overflow: "hidden",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            backgroundColor: "#f5f5f5" // optional (looks clean)
          }}
        >
          <Box
            component="img"
            src={imgSpitiExpedition}
            alt="Spiti Valley"
            sx={{
              width: "100%",
              height: "100%",
              objectFit: "contain"
            }}
          />
        </Box>
      </Stack>
    </Box>
  );
};

export default SpitiExpedition;
